import setSessionState from '@shoflo/studio-redux/actions/sessionState/setSessionState/setSessionState';

function sessionStateChanged({ dispatch }, { sessionState }) {
  dispatch(setSessionState(sessionState));
}

export default sessionStateChanged;
